import { Outlet } from "react-router";

function App() {
  return (
    <div className="min-h-screen flex flex-col pb-32 sm:pb-0">
      <Outlet />
    </div>
  );
}

export default App;
